// external imports
import React from 'react'
import Helmet from 'react-helmet'
import { Switch, Route, Redirect } from 'react-router-dom'
import { FlexColumn, AlertContainer, PrimaryButton, Text } from 'quark-web'
// local imports
import { darkGrey } from '~/colors'
import { Company, Splash, Research, Contact, Distributors, Products, Search, Offline } from '..'
import styles from './styles'
import './reset.css'
import Footer from './Footer'
import Nav from './Nav'

const Production = () => (
    <FlexColumn style={styles.container}>
        <Helmet titleTemplate="%s | Lark Seeds International" />
        <Nav />
        <section style={styles.content}>
            <Switch>
                <Route path="/company" component={Company} />
                <Route path="/research" component={Research} />
                <Route path="/contact" component={Contact} />
                <Route path="/distributors" component={Distributors} />
                <Route path="/products" component={Products} />
                <Route path="/search" component={Search} />
                <Route exact path="/" component={Splash} />
                <Route render={() => <Redirect to="/" />} />
            </Switch>
        </section>
        <Footer />
        <AlertContainer style={{ position: 'absolute', top: 10, left: 10, right: 10 }} />
    </FlexColumn>
)

const OffProduction = () => (
    <FlexColumn style={styles.container}>
        <Helmet titleTemplate="%s | Lark Seeds International" />
        <Nav />
        <section style={styles.content}>
            <Switch>
                <Route path="/" component={Offline} />
                <Route render={() => <Redirect to="/" />} />
            </Switch>
        </section>
        <Footer />
    </FlexColumn>
)

export default Production


// WEBPACK FOOTER //
// ./src/views/Root/index.js